import { useReactFlow } from '@xyflow/react';
import { useCallback } from 'react';

import { tidyGrid, tidyHorizontalLine, tidyNodes, tidyVerticalLine } from '../../../utils/layout/nodeTidy';
import { useLayoutCommandExecutor } from './useLayoutCommandExecutor';

export function useTidyNodes() {
  const { getViewport } = useReactFlow();
  const executeLayout = useLayoutCommandExecutor();

  const onTidyUp = useCallback(
    () => executeLayout((rects) => tidyNodes(rects, getViewport().zoom)),
    [executeLayout, getViewport],
  );
  const onTidyHorizontal = useCallback(() => executeLayout((rects) => tidyHorizontalLine(rects)), [executeLayout]);
  const onTidyVertical = useCallback(() => executeLayout((rects) => tidyVerticalLine(rects)), [executeLayout]);
  const onTidyGrid = useCallback(
    () => executeLayout((rects) => tidyGrid(rects, getViewport().zoom)),
    [executeLayout, getViewport],
  );

  return { onTidyGrid, onTidyHorizontal, onTidyUp, onTidyVertical };
}
